import axios, { AxiosError } from "axios";

export const clientFactory = ({
  baseURL,
  apiPath,
  on401,
  clientMaxTimeout = 60 * 1000,
}: {
  baseURL: string;
  apiPath: string;
  clientMaxTimeout?: number;
  on401?: (error: AxiosError) => void;
}) => {
  const client = axios.create({
    baseURL: new URL(apiPath, baseURL).href,
    withCredentials: true,
    timeout: clientMaxTimeout,
    headers: {
      "Content-type": "application/json",
    },
  });

  client.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      if (on401 && error.response?.status === 401) {
        on401(error);
      }

      throw error;
    }
  );

  return client;
};
